import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

function RuleBottomItem({ copy, image }: RuleBottomItemProps) {
  const { t } = useTranslation('wellBeing')

  return (
    <div className="flex flex-col items-center justify-center p-8 m-8 bg-[#545584] rounded-full md:rounded-5xl relative md:p-12 mb-28 md:mb-0 last:mb-12 md:last:mb-0 w-full">
      <div className="absolute w-32 h-32 my-8 -top-36 md:-top-32">
        <Image
          alt={t('results.none')}
          src={`/images/well-being/${image}.png`}
          height="10%"
          width="10%"
          layout="responsive"
          quality={75}
          loading="eager"
        />
      </div>
      <p className="text-sm text-center text-white">{t(`${copy}`)}</p>
    </div>
  )
}

type RuleBottomItemProps = {
  copy: string
  image: string
}

export default RuleBottomItem
